<template>
  <v-container class="ma-0 pa-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container class="ma-0 pa-0">
        <h1>{{$t('labels.confirmMobilePhone')}}</h1>
        <p>
          {{ $t('application.mobilephone.confirmPage-text') }}
          <span
            class="phone"
          >{{ mobilephone | phoneNo }}.</span>
          {{ $t('application.mobilephone.confirmPage-text2') }}
        </p>
        <v-text-field
          ref="phone"
          v-shortkey="['enter']"
          @shortkey.native="nextStep"
          v-model="code"
          prepend-icon="$sl-confirm"
          placeholder="1234"
          maxlength="4"
          :rules="[rules.required, rules.integer, rules.confirmCode]"
        ></v-text-field>
      </v-container>

      <NextButton
        class="mt-3"
        @enter="nextStep"
        :isEnterSubmit="true"
        @click="nextStep"
        :isDisabled="isImitatingUser()"
      >{{$t('labels.email')}}</NextButton>
    </v-form>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import omit from 'lodash/omit'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'

// @group Registration
// Styled MobilephoneConfirm component

export default {
  name: 'MobilephoneConfirm',

  mixins: [RulesMixin],

  data: () => ({
    code: null,
    valid: true
  }),
  components: {
    NextButton
  },
  props: {
     //has mobilephone
    mobilephone: {
       // `'String'` / 
      type: String,
      // The default value is: ` '' `
      default: ''
    }
  },

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser'])
  },

  methods: {
    /**
     * @vuese
     * Used to go to verify phone number with the code and move to step 2
     * @arg The argument is an integer representing sending code
     */
    nextStep() {
      if (this.code && this.code.length == 4) {
        API.updatePerson({phoneVerification: this.code})
          .then(response => {
            if (response.data.phoneVerified) {
              // Fire goToStep event 
             // @arg The argument is a integer representing step number
              this.$emit('goToStep', {step: 2})
            } else {
              this.$events.fire('showError', this.$t('errors.code-failure'))
            }
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.save-failure'))
            console.log('There was an error:', error)
          })
      } else {
        this.$events.fire('showError', this.$t('errors.save-failure'))
      }
    }
  }
}
</script>

<style scoped>
.phone {
  white-space: nowrap;
  font-weight: bold;
}
</style>